import { IInsuranceBundle } from '@/services/types/booking/insuranceBundle';

export const isPeaceOfMindInsuranceBundle = (insuranceBundle?: IInsuranceBundle) => {
  return insuranceBundle?.name === 'Peace of Mind' || insuranceBundle?.tier === 3;
};

export const isStationaryDeliveryInsuranceBundle = (insuranceBundle?: IInsuranceBundle) => {
  return insuranceBundle?.name === 'Stationary';
};
